/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SurveyType } from './surveyType';


/**
 * 
 */
export interface Survey { 
    /**
     * 
     */
    id?: number;
    /**
     * 
     */
    editTS?: string;
    /**
     * 
     */
    status: Survey.StatusEnum;
    /**
     * 
     */
    title: string;
    /**
     * 
     */
    supervisor?: string;
    /**
     * 
     */
    supervisorId?: number;
    /**
     * 
     */
    periodId?: number;
    /**
     * 
     */
    startDate?: string;
    /**
     * 
     */
    endDate?: string;
    /**
     * 
     */
    departmentId?: number;
    /**
     * 
     */
    internshipYear?: number;
    /**
     * 
     */
    locationId?: string;
    type: SurveyType;
    /**
     * 
     */
    typeDescr: string;
    /**
     * 
     */
    deadline?: string;
    /**
     * 
     */
    reminderId?: number;
}
export namespace Survey {
    export type StatusEnum = 'SAVED' | 'DRAFT' | 'TODO';
    export const StatusEnum = {
        Saved: 'SAVED' as StatusEnum,
        Draft: 'DRAFT' as StatusEnum,
        Todo: 'TODO' as StatusEnum
    };
}


